import { render, staticRenderFns } from "./LinhaDeParcelas.vue?vue&type=template&id=8e4e801e&scoped=true"
import script from "./LinhaDeParcelas.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeParcelas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeParcelas.vue?vue&type=style&index=0&id=8e4e801e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e801e",
  null
  
)

export default component.exports